<ideal-drawer-group [openDrawerIndex]="selectedDrawerIndex()">
  @for (item of drawers(); track item) {
    <ideal-drawer position="right">
      <ng-container *ngTemplateOutlet="item.template; context: getItemContext(item, $index); injector: item.injector"></ng-container>
    </ideal-drawer>
  }
</ideal-drawer-group>
